import { STORE_LOCATIONS } from '../../location/locationHelper';

export type SupportRequestPrefillData = {
  email?: string;
  firstName?: string;
  lastName?: string;
  subject?: string;
  enquiryType?: string;
  accountEnquiryType?: string;
  orderNumber?: string;
};

export const supportRequestInputIdentifiers: Record<keyof SupportRequestPrefillData, string> = {
  email: 'tf_anonymous_requester_email',
  firstName: 'tf_360049469013',
  lastName: 'tf_360051171874',
  subject: 'tf_subject',
  enquiryType: 'tf_360052113773',
  orderNumber: 'tf_360027996773',
  accountEnquiryType: window.Jbhifi?.storeLocation === STORE_LOCATIONS.NZ ? 'tf_14820213889689' : 'tf_360052113773',
};
